/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BalanceOverview/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function BalanceOverview({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content/Content/BalanceOverview"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let newPaymentPlanInvoiceAmountValueData = fromData.useDataValue({ viewPath,
context: 'new_payment_plan',
path: 'invoice_amount',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let newPaymentPlanInvoiceAmountValueData1 = fromData.useDataValue({ viewPath,
context: 'new_payment_plan',
path: 'invoice_amount',
})
let receivableBalanceAmountValueData = fromData.useDataValue({ viewPath,
context: 'receivable',
path: 'balance_amount',
})
let aggregateData = fromHelpers.isError(newPaymentPlanInvoiceAmountValueData1, receivableBalanceAmountValueData)
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let newPaymentPlanInvoiceAmountValueData2 = fromData.useDataValue({ viewPath,
context: 'new_payment_plan',
path: 'invoice_amount',
})
let receivableBalanceAmountValueData1 = fromData.useDataValue({ viewPath,
context: 'receivable',
path: 'balance_amount',
})
let aggregateData1 = fromHelpers.isError(newPaymentPlanInvoiceAmountValueData2, receivableBalanceAmountValueData1)
let dtColorsRed600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.600'
        })
let constantData = '$'
let receivableBalanceAmountValueData2 = fromData.useDataValue({ viewPath,
context: 'receivable',
path: 'balance_amount',
})
let aggregateData2 = fromAggregate.join(constantData, receivableBalanceAmountValueData2)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let newPaymentPlanInvoiceAmountValueData3 = fromData.useDataValue({ viewPath,
context: 'new_payment_plan',
path: 'invoice_amount',
})
let receivableBalanceAmountValueData3 = fromData.useDataValue({ viewPath,
context: 'receivable',
path: 'balance_amount',
})
let aggregateData3 = fromHelpers.calcRemainingAmount(newPaymentPlanInvoiceAmountValueData3, receivableBalanceAmountValueData3)
  return (<React.Fragment
>
<div
  data-testid="BalanceOverview.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-1Rh20Y': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="BalanceOverview.Vertical"
  data-view-path={viewPath}
 style={{'--mr-2-1Rh20Y': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 key="Invoice Amount"
 marginTop={0}
 data="new_payment_plan.invoice_amount"
 value={newPaymentPlanInvoiceAmountValueData}
 validate="/Data/validate.js validateCurrency"
 onChange={onChange}
 required={true}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Total amount to be paid"
 weight="medium"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 backgroundColor="white"
 borderColor={dtColorsNeutral300}
 data="new_payment_plan.invoice_amount"
 data="receivable.balance_amount"
 aggregate="helpers.js isError"
 invalid={aggregateData}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="currency"
/>
)}
</TysiaInputContent>
<fromFlow.When is={aggregateData1}>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 data="new_payment_plan.invoice_amount"
 data="receivable.balance_amount"
 aggregate="helpers.js isError"
 text="Amount to be paid cannot be more than invoice amount"
 color={dtColorsRed600}
/>
</fromFlow.When>
</React.Fragment>
)}
</TysiaInput>
</div>
<div
  data-testid="BalanceOverview.Vertical:1"
  data-view-path={viewPath}
 style={{'--ml-3-1Rh20Y': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-1-1Rh20Y': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="BalanceOverview.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Invoice Amount:"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 marginLeft={dtSpaceXxs}
 data="'$'"
 data="receivable.balance_amount"
 aggregate="/Data/aggregate.js join"
 text={aggregateData2}
/>
</div>
<div
  data-testid="BalanceOverview.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Invoice Remainder:"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 marginLeft={dtSpaceXxs}
 data="new_payment_plan.invoice_amount"
 data="receivable.balance_amount"
 aggregate="helpers.js calcRemainingAmount"
 text={aggregateData3}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}